<template>
    <div class="p-3">
        <app-header class="mb-3" title="历史航次"/>
        <div v-if="loading" class="text-center w-100">
            <b-spinner label="Spinner"/>
        </div>
        <template v-else>
            <div class="mb-2 d-flex align-items-center justify-content-between">
                <div v-if="vesselName">
                    船名：
                    <a v-if="hash" class="anchor" target="_blank"
                       :href="`/voyage.html?hash=${hash}&delegation=${delegationId}&origin=contact`">{{vesselName}}</a>
                    <span v-else>{{vesselName}}</span>
                    <span v-if="items.length > 0">(MMSI：{{items[0].mmsi}})</span>
                </div>
                <div v-if="delegation && delegation.object">
                    关联货盘航线：<a target="_blank" :href="`/palletDelegation.html?id=${delegationId}`"
                              class="anchor">{{delegationStart}}→{{delegationTarget}}</a>
                </div>
                <div></div>
            </div>
            <div v-if="calculating" class="text-center w-100">
                <b-spinner label="Spinner"/>
            </div>
            <table v-if="items.length > 0" class="table table-bordered table-sm text-center">
                <thead>
                <tr>
                    <th>序号</th>
                    <th>开始时间</th>
                    <th>结束时间</th>
                    <th>时间间隔</th>
                    <th>作业码头</th>
                    <th>始发港</th>
                    <th>目的港</th>
                    <th>航程</th>
                    <th>方向</th>
                    <th>平均航速</th>
                    <td v-if="withCargoInfo">空重</td>
                    <th>出发航速</th>
                    <th>到达航速</th>
                    <th>详情</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in items" :key="item.id" :class="item.backgroundClass">
                    <td>{{index + 1}}</td>
                    <td>{{item.beginTime | momentFormat('YYYY-MM-DD HH:mm')}}</td>
                    <td>{{item.endTime | momentFormat('YYYY-MM-DD HH:mm')}}</td>
                    <td>{{item.interval}}天</td>
                    <td>{{item.loadUnloadDockCount}}</td>
                    <td>{{item.beginText}}</td>
                    <td>{{item.endText}}</td>
                    <td>{{item.distance}}公里</td>
                    <td v-html="item.directionHtml"></td>
                    <td>{{item.speed || '——'}}节</td>
                    <td v-if="withCargoInfo" v-html="item.cargoHtml"></td>
                    <td>{{item.first4HourSpeed || '——'}}节</td>
                    <td>{{item.last4HourSpeed || '——'}}节</td>
                    <td><a class="anchor" target="_blank" :href="item.detailLink">详情</a></td>
                </tr>
                </tbody>
            </table>
            <div v-if="!calculating && !items.length" class="text-center">
                <div class="h5">无历史航次</div>
            </div>
        </template>
    </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import NewShip from "@/services/newShip";
import Delegation from "@/services/delegation";
import SailRoute from "@/services/sailRoute";
import * as moment from "moment";

export default {
    name: "VesselHistoryRoute",
    components: {AppHeader},
    data() {
        return {
            hash: "",
            vesselName: "",
            delegationId: "",
            ship: null,
            delegation: null,
            items: [],
            loading: true,
            calculating: true,
            withCargoInfo: false,
        };
    },
    computed: {
        delegationStart() {
            return this.delegation.object.startText
                + this.riverCursorText(this.delegation.object.startRiver, this.delegation.object.startCursor);
        },
        delegationTarget() {
            return this.delegation.object.targetText
                + this.riverCursorText(this.delegation.object.targetRiver, this.delegation.object.targetCursor);
        },
    },
    methods: {
        riverCursorText(river, cursor) {
            if (river) {
                if (river[0] === "R") {
                    river = river.slice(1);
                }
                return `(${river}${cursor})`;
            }
            return "";
        },
        async load() {
            this.hash = this.$route.query["hash"] || "";
            this.vesselName = this.$route.query["name"] || "";
            this.delegationId = +this.$route.query["delegation"] || "";
            try {
                this.loading = true;
                if (this.hash) {
                    this.ship = await NewShip.getSimple(this.hash);
                    this.vesselName = this.ship && this.ship.name || "";
                } else if (this.vesselName) {
                    this.ship = await NewShip.getSimpleByName(this.vesselName);
                    this.hash = this.ship && this.ship.hash || "";
                }
                if (this.delegationId) {
                    this.delegation = await Delegation.loadWithRiverCursors(this.delegationId);
                }
            } finally {
                this.loading = false;
            }

            try {
                this.calculating = true;
                await this.calculate();
                this.calculating = false;
            } finally {
            }
        },
        updateSailRoute(items, pallet) {
            for (let i = 0; i < items.length; i++) {
                let item = items[i];
                let next = items[i + 1];
                item.interval = 0;
                if (next) {
                    let interval = moment(item.beginTime).diff(moment(next.endTime), "day", true);
                    item.interval = +interval.toFixed(1) || 0;
                }
                item.beginText = item.beginSegment
                    ? (item.beginSegment + this.riverCursorText(item.beginRiver, item.beginCursor)) : "——";
                item.endText = item.endSegment
                    ? (item.endSegment + this.riverCursorText(item.endRiver, item.endCursor)) : "——";
                item.backgroundClass = "";
                if (Number.isFinite(item.coverRate)) {
                    item.backgroundClass = item.coverRate ? "bg-weak-warning" : "bg-weak-success";
                } else {
                    item.backgroundClass = "";
                }
                let trailFrom = moment(item.beginTime).format("YYYY-MM-DD");
                let trailTo = moment(item.endTime).format("YYYY-MM-DD");
                item.detailLink = `/vue/search-map?mmsi=${item.mmsi}&vesselName=${this.vesselName}` +
                    `&trail=1&trailFrom=${trailFrom}&trailTo=${trailTo}&trailWash=1`;
                if (pallet) {
                    item.detailLink += `&startText=${pallet.startText}&targetText=${pallet.targetText}`;
                    if (pallet.maxWeight && pallet.maxWeight !== 2147483647) {
                        item.detailLink += "&maxWeight=" + pallet.maxWeight;
                    }
                }
                item.direction = item.direction || "";
                if (!item.direction) {
                    let beginDirection = item.beginRiver === "R长江" && item.beginRiverDirection;
                    let endDirection = item.endRiver === "R长江" && item.endRiverDirection;
                    if (beginDirection && endDirection) {
                        if (beginDirection === endDirection) {
                            item.direction = beginDirection;
                        }
                    } else {
                        item.direction = beginDirection || endDirection || "";
                    }
                }
                item.directionHtml = "";
                if (item.direction === "down") {
                    item.directionHtml = '<span class="text-success">下水</span>';
                } else if (item.direction === "up") {
                    item.directionHtml = '<span class="text-danger">上水</span>';
                }
                item.cargoHtml = "";
                if (item.cargo) {
                    if (item.cargo === "empty") {
                        item.cargoHtml = `<span class="text-success">空(${item.step})</span>`;
                    } else {
                        item.cargoHtml = `<span class="text-danger">重(${item.step})</span>`;
                    }
                }
            }
            this.items = items;
            this.withCargoInfo = items.find(x => x.cargo);
        },
        async calculate(loop) {
            let pallet = this.delegation && this.delegation.object;
            let params = {name: this.vesselName};
            if (pallet && pallet.start && pallet.target) {
                Object.assign(params, {
                    startPort: pallet.start.id, startTerminal: pallet.startTerminal,
                    targetPort: pallet.target.id, targetTerminal: pallet.targetTerminal,
                });
            }
            if (!loop) {
                let items = await SailRoute.listByVesselCurrent(params);
                this.updateSailRoute(items, pallet);
            }
            let items = await SailRoute.listByVessel(params);
            if (!items) {
                await new Promise(resolve => setTimeout(resolve, 1000));
                return await this.calculate(true);
            }
            this.updateSailRoute(items, pallet);
        }
    },
    created() {
        this.load();
    },
}
</script>

<style scoped>

</style>
